import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Trans } from "@lingui/react/macro";
import { BonusNotifierService } from "../../../../services/bonus-notifier";
import { Overlay } from "../user/menu-popup";
import { CloseIcon } from "../../utils/icons.jsx";

export default function PlayingWithBonusModal() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const showNotification = () => {
            setVisible(true);
        };

        BonusNotifierService.addListener(showNotification);

        return () => {
            BonusNotifierService.removeListener(showNotification);
        };
    }, []);

    const handleClose = () => {
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <Overlay onClick={handleClose}>
            <div class="bg-white rounded-lg shadow-lg text-center mx-auto w-full max-w-screen-sm flex-none">
                <div class="bg-blue-whale-500 p-4 rounded-t-lg relative">
                    <h2 class="text-2xl font-bold text-white"><Trans>Attention!</Trans></h2>
                    <button class="absolute top-2 right-2 text-white" onClick={handleClose}><CloseIcon class="h-4 fill-current" /></button>
                </div>
                <div class="p-6">
                    <p class="mb-4 text-lg "><Trans>Your Balance is 0.00. You are now playing with your Bonus Balance.</Trans></p>
                    <p class="mb-4 text-lg">{window.Translation("አሁን ያለዎትን ቀሪ ሂሳብ 0.00 ነው። በቦነስ መጫወት ይጀምሩ።")}</p>
                    <p class="mb-4 text-lg">{window.Translation("በቦነስ እየተጫወቱ ስለሆነ ማንኛውም የውርርድ ውጤት በቦነስ ብቻ ገቢ ይደረጋል። ህግና ደንቦች አሉት")}</p>
                    <div class="flex justify-center mt-4">
                        <button class="bg-blue-whale-500 text-white px-6 py-3 rounded-full mr-2 hover:bg-blue-whale-600 transition duration-300" onClick={handleClose}>
                            <Trans>I know</Trans>
                        </button>
                    </div>
                </div>
            </div>
        </Overlay>
    );
}